var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("section-title", {
        attrs: {
          content: "Áreas Geográficas",
          icon: "fas fa-map-marker-alt",
          reverse: ""
        }
      }),
      _c(
        "div",
        { staticClass: "bg-secondary-3 rounded pr-3 pl-3 mt-3 pb-4 pt-4" },
        [
          _c("div", { staticClass: "color-gray-6 font-14" }, [
            _vm._v(" Municipio(s): ")
          ]),
          _c(
            "div",
            { staticClass: "items__container" },
            _vm._l(_vm.items, function(item) {
              return _c(
                "span",
                { key: item.id, staticClass: "item__container" },
                [_vm._v(" " + _vm._s(item.name) + " ")]
              )
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }